import React, { useEffect, useState } from 'react'
import apiClient from '../../utils/axiosPetition';
import { alertaCargandoProceso, alertaGeneral } from '../../utils/alertas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimesCircle, faClock, faCommentAlt } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Archivo } from '../../assets/icons/archivo.svg';
import SvgIcon from '../../utils/Icon';


const TableDocuments = ({ lstDocuments = [], filesToEdit = {}, showGuardarCambios, onClickGuardarCambios, setFilesToEdit = () => { }, doctorEstado }) => {
    /* Estructura de lstDocuments: 
    nameToSave, name, url, isEdit; opcionales: isApproved (true=aprobado, false=rechazado, null/undefined=pendiente), rejectionReason (string)
    Si isApproved/rejectionReason están presentes, se muestra estado y observaciones en "Documentos almacenados".
    doctorEstado: 'en_revision' | 'rechazado' | 'aprobado' para mostrar "En revisión" cuando corresponda (evita mostrar "Rechazado" en docs recién enviados).
    */

    const [isUrlExists, setIsUrlExists] = useState(false);

    useEffect(() => {
        /*Este useEffect es para cuando se le entregue la funcion setFilesToEdit, se limpie de nuevo
        pues si le entregan esta funcion de nuevo, quiere decir que se renderizo nuevamente este componente*/
        return () => {
            setFilesToEdit([]);
        }
    }, [setFilesToEdit])

    useEffect(() => {
        if (lstDocuments == null || lstDocuments?.length == 0) return;
        const isSomeUrl = lstDocuments.some(file => file.url); //Verificamos si hay al menos un archivo con url
        setIsUrlExists(isSomeUrl);
    }, [lstDocuments])

    const [isUpdateFile, setIsUpdateFile] = useState({});

    const onHandleClickView = (url) => {
        window.open(url, '_blank');
    }


    const onHandleEdit = (ev) => {
        /*
            La variable isUpdateFile es para saber si se ha seleccionado un archivo para actualizar
            y posteriormente mostrar el mensaje de 'Archivo a actualizar' y un icono de check
            La variable filesToEdit es para almacenar el archivo seleccionado
        */
        if (ev.target.files.length === 0) {
            console.log("No llegaron archivos");
            setIsUpdateFile({ ...isUpdateFile, [ev.target.name]: false });
            setFilesToEdit({ ...filesToEdit, [ev.target.name]: null });
            return;
        }
        setIsUpdateFile({ ...isUpdateFile, [ev.target.name]: true });
        setFilesToEdit({ ...filesToEdit, [ev.target.name]: ev.target.files[0] });
    }

    return (
        <div className="mt-3">
            {isUrlExists &&
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    {showGuardarCambios && (
                        <div className="bg-[#1f94c2ff] px-4 py-3 border-b border-[#205087ff]">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center">
                                    <SvgIcon Icon={Archivo} className={"w-6 h-6 text-white mr-3"} />
                                    <span className="text-white font-semibold text-base">Documentos almacenados</span>
                                </div>
                                <button
                                    type="button"
                                    onClick={onClickGuardarCambios}
                                    className="px-3 py-1.5 text-sm font-semibold bg-white text-[#1f94c2] rounded-md hover:bg-white/90 transition-colors"
                                >
                                    Guardar cambios
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="divide-y divide-gray-200">
                        {
                            lstDocuments.filter(f => f.url != '').map((file, index) => (
                                <div key={index} className="px-4 py-3 hover:bg-gray-50 transition-colors">
                                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                        <div className="flex-1 min-w-0">
                                            <p className="text-base font-medium text-gray-800">{file.name}</p>
                                            <div className="flex flex-wrap items-center gap-2 mt-1.5">
                                                {'isApproved' in file && file.isApproved === true && (
                                                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
                                                        <FontAwesomeIcon icon={faCheck} className="w-3.5 h-3.5" />
                                                        Aprobado
                                                    </span>
                                                )}
                                                {'isApproved' in file && file.isApproved === false && (file.rejectionReason || doctorEstado !== 'en_revision') && (
                                                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-red-50 text-red-700 border border-red-200">
                                                        <FontAwesomeIcon icon={faTimesCircle} className="w-3.5 h-3.5" />
                                                        Rechazado
                                                    </span>
                                                )}
                                                {'isApproved' in file && (file.isApproved === null || file.isApproved === undefined || (file.isApproved === false && doctorEstado === 'en_revision' && !file.rejectionReason)) && file.url && (
                                                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200">
                                                        <FontAwesomeIcon icon={faClock} className="w-3.5 h-3.5" />
                                                        En revisión
                                                    </span>
                                                )}
                                            </div>
                                            {'isApproved' in file && file.isApproved === false && file.rejectionReason && (
                                                <div className="mt-2 pl-3 py-2 pr-3 rounded-lg bg-red-50/80 border-l-4 border-red-300 flex gap-2">
                                                    <FontAwesomeIcon icon={faCommentAlt} className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
                                                    <div>
                                                        <span className="text-xs font-semibold text-red-700">Observación del revisor</span>
                                                        <p className="text-sm text-red-800 mt-0.5 leading-snug">{file.rejectionReason}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {isUpdateFile[file.nameToSave] && (
                                                <div className="flex items-center mt-1.5">
                                                    <p className="text-sm text-gray-600 mr-2">Archivo a actualizar</p>
                                                    <FontAwesomeIcon icon={faCheck} className="text-green-500 text-sm" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex flex-wrap gap-2">
                                            <button 
                                                className="px-4 py-2 bg-[#1f94c2ff] hover:bg-[#205087ff] text-white text-base font-medium rounded-lg transition-colors shadow-sm hover:shadow-md"
                                                onClick={() => onHandleClickView(file?.url)}
                                            >
                                                Ver
                                            </button>
                                            <button 
                                                className="px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 text-base font-medium rounded-lg transition-colors border-2 border-gray-300 hover:border-[#1f94c2ff] shadow-sm hover:shadow-md"
                                                onClick={() => onHandleClickDownload(file.url, file.name)}
                                            >
                                                Descargar
                                            </button>
                                            {file.isEdit && (
                                                <label className="px-4 py-2 bg-[#f79865ff] hover:bg-[#ffa16f] text-white text-base font-medium rounded-lg transition-colors cursor-pointer shadow-sm hover:shadow-md">
                                                    Editar
                                                    <input name={file.nameToSave} type="file" accept=".png, .jpg, .jpeg, .pdf" hidden onChange={(ev) => onHandleEdit(ev)} />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export const onHandleClickDownload = (fileUrl, fileName) => {
    fileName = fileName.replace(/ /g, '_'); // Reemplazar espacios en el nombre del archivo
    alertaCargandoProceso({
        titulo: 'Descargando archivo',
        messageHtml: 'Espere un momento por favor...',
        funcionAsync: () => {
            // Obtener la respuesta desde el backend (encriptada)
            apiClient.post(`/api/files/send-files`, { url: fileUrl })
                .then((response) => {

                    // Verificar si la respuesta contiene un archivo en Base64
                    if (response.data) {
/*                         const { contentType, buffer } = response.data;

                        // Decodificar el Base64 a un Uint8Array
                        const fileBuffer = Uint8Array.from(atob(buffer), (c) => c.charCodeAt(0));

                        // Convertir el Uint8Array en un Blob
                        const blob = new Blob([fileBuffer], { type: contentType });

                        // Crear una URL de descarga para el Blob
                        const url = window.URL.createObjectURL(blob);

                        // Crear un enlace temporal para iniciar la descarga
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove(); // Eliminar el enlace después de hacer clic */

                        alertaGeneral({
                            titulo: 'Descarga completada',
                            messageHtml: 'El archivo se ha descargado correctamente',
                        });
                    }
                })
                .catch((error) => {

                    console.error("Error al descargar el archivo:", error);
                    alertaGeneral({
                        titulo: 'Error',
                        messageHtml: 'Hubo un problema al descargar el archivo. Por favor, inténtalo de nuevo.',
                        isError: true,
                    });
                })
        }
    });
};


export default TableDocuments;